import { registerAction } from '../../Action'

const CSV_CREATED = 'CSV_CREATED'

const reducer = (state = {}, action) => ({
  ...state,
  csvCreated: action.payload.created,
})

const setCSVCreated = registerAction(CSV_CREATED, { reducer })

export default setCSVCreated
